import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import LoginIcon from '@mui/icons-material/Login';

export default function PageUnauthorized() {
    return (
        <React.Fragment>
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100vh',
                    py: 4
                }}
            >
                <Container maxWidth="md">
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: { xs: 4, md: 6 }
                        }}
                    >
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 120,
                                height: 120,
                                borderRadius: '50%',
                                bgcolor: 'warning.main',
                                color: 'white',
                                mb: 3,
                                boxShadow: 3
                            }}
                        >
                            <LockIcon sx={{ fontSize: 72 }} />
                        </Box>

                        <Typography
                            variant="h1"
                            sx={{
                                fontSize: { xs: '6rem', md: '8rem' },
                                fontWeight: 700,
                                color: 'warning.main',
                                mb: 2,
                                lineHeight: 1
                            }}
                        >
                            401
                        </Typography>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 600,
                                mb: 2,
                                color: 'text.primary'
                            }}
                        >
                            Acesso não autorizado
                        </Typography>

                        <Typography
                            sx={{
                                color: 'text.secondary',
                                fontSize: '1.1rem',
                                mb: 4,
                                maxWidth: 600,
                                mx: 'auto',
                                lineHeight: 1.7
                            }}
                        >
                            Para ter acesso a essa área é necessário se autenticar. Utilize a página de login para realizar a autenticação e obter as permissões necessárias.
                        </Typography>

                        <Button
                            to="/"
                            size="large"
                            variant="contained"
                            component={RouterLink}
                            startIcon={<LoginIcon />}
                            sx={{
                                minWidth: 200,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '1rem',
                                py: 1.5,
                                mt: 2
                            }}
                        >
                            Ir para o Login
                        </Button>
                    </Box>
                </Container>
            </Box>
        </React.Fragment>
    )
}